import { z } from 'zod'

import { dateSchema } from '~/shared/lib/schemas'
import { ApiModel } from './core'

const attributeSchema = z.object({
  extId: z.string(),
  fullName: z.string(),
})

const schema = z
  .object({
    createdAt: dateSchema.optional(),
    updatedAt: dateSchema.optional(),
  })
  .merge(attributeSchema)

export type DriverAttributes = z.infer<typeof attributeSchema>

/*
 * Данные водителя, которыми заполняются поля штрафа при ручном создании.
 * */
export type DriverFormOption = {
  id: UniqueId
  label: string
  tmsDriver: string
  tmsDriverName: string
}

export class Driver extends ApiModel<typeof schema, DriverAttributes> {
  static jsonApiType = 'drivers'

  static schema = schema

  getFullName(): string {
    return this.getAttribute('fullName')
  }

  getFormOption(): DriverFormOption {
    return {
      id: this.getApiId() as UniqueId,
      label: this.getFullName(),
      tmsDriver: this.getAttribute('extId'),
      tmsDriverName: this.getFullName(),
    }
  }

  static async fetchOptions(search: string): Promise<DriverFormOption[]> {
    const response = await Driver.where('fullName', search).get(1)
    return response.getData().map((driver) => driver.getFormOption())
  }
}
